import {Record, List} from 'immutable';
import {schema} from 'normalizr';
import {WorkflowStatusSchema} from './WorkflowStatus';

const Workflow = Record({
    id: null,
    statuses: List(),
    replyStatus: null,
});

export const WorkflowSchema = new schema.Entity('workflow', {
    statuses: [WorkflowStatusSchema],
    replyStatus: WorkflowStatusSchema,
});

export default Workflow;
